import * as React from 'react'
import Menu from '@mui/material/Menu'
import { useState } from 'react'

// style
import { Drawer, IconButton, Tooltip, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import { Box } from '@mui/system'
import useStyles from './useStyles'
import { UserOrgSeeMore } from '../../../../components/Modals/Organizations/User/RightModals/UserSuscriberSeeMore'
import { ModalChangeAdminME } from '../../../../components/Modals/Organizations/User/ModalChangeAdminME/ChangeAdminME'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
export default function ModalMenuItemUserOrg ({ item, setLoading }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const [stateSeeMore, setstateSeeMore] = useState(false)
  // const [editUserOfOrganization, setEditUserOfOrganization] = useState(false)
  const [modalChangeUserAdmin, setModalChangeUserAdmin] = useState(false)

  const handleClickButton = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  // const listEditUser = (anchor) => (
  //   <Box
  //     sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 500 }}
  //     role="presentation"
  //   >
  //     <StepperEditUserOfOrganization
  //       setEditUserOfOrganization={setEditUserOfOrganization}
  //       setLoading={setLoading}
  //       item={item}
  //     />
  //   </Box>
  // )
  const handleOpen = () => {
    setModalChangeUserAdmin(true)
  }
  const listSeeMoreUser = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 800 }}
      role="presentation"
    >
      <UserOrgSeeMore
        style={{ marginTop: '5%' }}
        setLoading={setLoading}
        setstateSeeMore={setstateSeeMore}
        item={item}
      />
    </Box>
  )

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickButton}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          item={item}
          onClose={handleClose}
          setstateSeeMore={setstateSeeMore}
          handleOpen={handleOpen}
          // setEditUserOfOrganization={setEditUserOfOrganization}
        />
      </Menu>
      {/* <Drawer anchor={'right'} open={editUserOfOrganization}>
        {listEditUser('right')}
      </Drawer> */}
      <Drawer anchor={'right'} open={stateSeeMore}>
        {listSeeMoreUser('right')}
      </Drawer>
      <ModalChangeAdminME
        userId={item.userId}
        modalChangeUserAdmin={modalChangeUserAdmin}
        setModalChangeUserAdmin={setModalChangeUserAdmin}
      />
    </>
  )
}

function FiltersList ({
  item,
  setLoading,
  onClose,
  setstateSeeMore,
  handleOpen
}) {
  const classes = useStyles()

  return (
    <Box
      sx={{
        width: 250
      }}
      className={classes.boxStyle}
      onClick={onClose}
    >
      <Tooltip title="Ver detalles">
        <IconButton
          onClick={() => {
            onClose()
            setstateSeeMore(true)
          }}
        >
          <Box className={classes.boxTypography}>
            <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
            <Typography className={classes.typographyStyle}>
              Ver detalles
            </Typography>
          </Box>
        </IconButton>
      </Tooltip>
      {/* <Tooltip title="Editar">
        <IconButton
          onClick={() => {
            onClose()
            setEditUserOfOrganization(true)
          }}
        >
          <Box className={classes.boxTypography}>
            <EditIcon className={classes.hoverButton} />
            <Typography className={classes.typographyStyle}>Editar</Typography>
          </Box>
        </IconButton>
      </Tooltip> */}
      {item?.status?.userStatusCode === 'ACTIVE' &&
        (item?.type?.organizationUserTypeCode === 'ORG-STAFF' ||
          item?.type?.organizationUserTypeCode === 'ORG-ADMIN') && (
          <Tooltip title="Configurar usuario Mi Estudio">
            <IconButton
              onClick={() => {
                onClose()
                handleOpen()
              }}
            >
              <Box className={classes.boxTypography}>
                <AssignmentIndIcon className={classes.hoverButton} />
                <Typography className={classes.typographyStyle}>
                  Configurar usuario Mi Estudio
                </Typography>
              </Box>
            </IconButton>
          </Tooltip>
      )}
    </Box>
  )
}
